import { BusinessError } from '@/api/envelope';
import { api } from '@/services';
import { FiltrosDocumentos, ListaDocumentosPayload, ListaDocumentosResponse } from '../types';
import { normalizeListaDocumentosResponse } from './normalizers';

export async function fetchListaDocumentos(
  filtros?: FiltrosDocumentos
): Promise<ListaDocumentosResponse> {
  // Detectar se fornecedor é CNPJ ou razão social
  const fornecedorValor = filtros?.cnpj || filtros?.razaoSocial || '';
  const isCNPJ = /^\d{14}$/.test(fornecedorValor.replace(/\D/g, ''));

  const cnpjContribuinte = filtros?.empresaCnpjs || filtros?.empresaId || '';

  const payload: ListaDocumentosPayload = {
    pagina_numero: filtros?.paginaNumero || 1,
    pagina_quantidade_por: filtros?.paginaQuantidadePor || 25,
    cnpj: isCNPJ ? fornecedorValor.replace(/\D/g, '') : '',
    razao_social: !isCNPJ && fornecedorValor ? fornecedorValor : '',
    data_emissao_de: filtros?.dataInicio || '',
    data_emissao_ate: filtros?.dataFim || '',
    chave_acesso: filtros?.chaveAcesso || '',
    numero: filtros?.numeroDoc || '',
    Status: filtros?.status ?? '',
    evento: filtros?.evento ?? '',
    produto_lista_cfop: [],
    entrada_saida: filtros?.entradaSaida || '1',
    cnpj_contribuinte: cnpjContribuinte,
    busca: filtros?.busca || '',
    finalidade: filtros?.finalidade || '',
  };

  const response = await api.post<ListaDocumentosResponse, ListaDocumentosPayload>(
    'Documento/ListaDocumentos',
    payload
  );

  if (response?.status?.resultado === false) {
    throw new BusinessError(response.status.mensagem);
  }

  return normalizeListaDocumentosResponse(response);
}
